<template>
  <div>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
        
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 556px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext" :class="formatvhtml"></h1>
        </div>
      </main>
   
    </section>

 <div class="seven3css">
   <SeventyThirtysection :LeftsideText="sustsec1text"  :RightsideText="susthighlight" 
   :breadcrumbsinfo="breadcrumbsinfo" breadcrumtheme="breadcrumcss"/>
 </div>
 
 <div class="formatsdgs">
  <AllSdgs :getallgoalsmapping="sdgsmappingsinfo" :getallsdgslisting="sdgslistinginfo" carddivtheme="carddivcss"/>
  </div>

 <div class="allreports">
  <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
  :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
  :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" 
  :bgimage="bgimage" :showbg="showbg" :showrptfulltext="showrpttext"
  />
</div>


  <div style="padding: 100px;">
    <hr />
    <div v-html="bottomtext" style="text-align: center;">
    
    </div>
  </div>
    <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import SeventyThirtysection from '@/components/SeventyThirtysection.vue';
import AllReports from '@/components/AllReports.vue';
import AllSdgs from '@/components/AllSdgs.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
import AllSlides from '@/components/AllSlides.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import Chart from 'chart.js/auto';
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, SeventyThirtysection, AllReports, AllSdgs, BreadCrumbs, AllSlides
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,


  // corpgovernpolicy: [],
  sustsec1text: '',
  susthighlight: '',
  bottomtext: '',

  sdgsmappingsinfo: [],
  sdgslistinginfo: [],

  // SliderData: [],
  bgimage: '',
  showbg: 'True',
  newsphoto: '',

  reportpresentation: [],
  lastrecordsreportpresent: [],
  myPicUrl: '',

  showrpttext: false,
  showbg: false,

  gcolorcodes: [],
  breadcrumbsinfo: [],

  height: 0,
  width: 0,
  }
},
methods: {

},

async mounted() {
  this.myPicUrl = myUrlPath
await axios.get('allpagespv/healthandsafety').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
        console.log(error)
      })
   //------------corpgovernance info---------------
   await axios.get('gethealthandsafetyinfo/').then(
    response => {
        this.sustsec1text = response.data[0].hsdesc
        this.bottomtext = response.data[0].bottomtext
        console.log(response.data)
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------sdgs mappings info---------------
 await axios.get('getsdgcmappings/healthandsafety').then(
    response => {
        this.sdgsmappingsinfo = response.data

  })
  .catch((error) => {
      console.log(error)
    })

  //------------sdgs Listing info---------------
    await axios.get('getsdgslistings/').then(
    response => {
        this.sdgslistinginfo = response.data
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })


  //------------all highlights---------------
  await axios.get('getallhiglights/healthandsafety').then(
    response => {
        this.susthighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })

         //------------breadcrumbs mappings info---------------
    await axios.get('getbreadcrumbsinfo/healthandsafety').then(
        response => {
            this.breadcrumbsinfo = response.data

    })
    .catch((error) => {
        console.log(error)
        })

  //------------Get Reports---------------
  await axios.get('reportpresentationlisting/healthandsafety').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.bgimage = response.data.bgimage
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.showrpttext = response.data.showrptfulltext
        this.bgimage = response.data.bgimage
        this.showbg = response.data.showbgimage
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })
}
}
</script>

<style scoped>

.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.formatrow {
  margin-top: 340px;
  padding-left: 100px;
  padding-right: 100px;
}
.seven3css {
  margin-top: 100px;
}

.reportpresentcss {
  margin-top: 300px;
}
.imagecss {
  width: 80%;
  padding-left: 50px;
  padding-bottom: 100px;
}
.pushsection {
  margin-top: -100px;
  background-color: white;
  padding: 30px;
}
.seven3css {
  width: 84%;
  margin: 0 auto;
  margin-top: 200px;
}
.breadcrumcss {
  margin-top: -200px;
}
/* Move the background and make it larger. 
/* Media Query CSS*/
/* Move the background and make it larger. 
/* Media Query CSS*/
@media only screen and (max-width: 600px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .reportpresentcss {
      margin-top: 600px;
    }
    .txtdata {
      margin-bottom: 100px;
      width: 400px;
      padding-right: 10px;
    }
    .formatsdgs {
        padding-left: 20px;
        padding-right: 20px;
    }
  
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .txtdata {
      margin-bottom: 200px;
      width: 600px;
      padding-right: 10px;
    }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .txtdata {
      margin-bottom: 30px;
      width: 700px;
      padding-right: 10px;
    }
}


/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .txtdata {
    margin-bottom: 30px;
    width: 800px;
    padding-right: 10px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
.slidercss {
  margin-bottom: 300px;
}
.txtdata {
  margin-bottom: 100px;
  width: 900px;
  padding-right: 10px;
}
.carddivcss{
  padding-left: 70px;
  padding-right: 70px;
  padding-bottom: 200px;
}
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

}

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1600px) {

}
</style>
